<template>
  <div class="w-full">
    <div class="table-operator" v-if="!disabled">
      <a-button @click="handleTableAdd" icon="plus" type="primary">新增</a-button>
      <a-button @click="handleTableSave" icon="save">保存</a-button>
    </div>
    <j-vxe-table
      :columns="tableColumns"
      :dataSource="dataSource"
      :disabled="disabled"
      :height="300"
      :loading="loading"
      @edit-closed="handleEditClosed"
      keep-source
      ref="vTable"
      row-selection
    >
      <template v-if="!disabled" v-slot:action="props">
        <a-button @click="handleCopy(props)" class="mr-10px" icon="copy" key="copy" size="small"></a-button>
        <a-popconfirm @confirm="handleDL(props)" title="确定删除吗？">
          <a-button icon="delete" key="delete" size="small" type="danger"></a-button>
        </a-popconfirm>
      </template>
    </j-vxe-table>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { JVXETypes } from '@/components/jeecg/JVxeTable'
  import { getAction, postAction, deleteAction } from '@/api/manage';

  export default {
    // 备件挂载型号专用
    name: 'BjZy',
    components: {

    },
    props: {
      disabled: {
        type: Boolean,
        default: false,
        required: false
      },
      modelId: {
        type: String,
        default: '',
        required: false
      },
      modelName: {
        type: String,
        default: '',
        required: false
      },
      model: {
        type: Object,
        default: () => { }
      }
    },
    // 定义属性
    data () {
      return {
        tableColumns: [
          {
            width: '180px',

            title: '备件名称',
            key: 'bjName',
            type: JVXETypes.input,
            // fixed: 'left',
            defaultValue: '',
            sortable: true
          },
          {
            width: '160px',

            title: '备件型号',
            key: 'bjModel',
            type: JVXETypes.input,
            // fixed: 'left',
            defaultValue: '',
            sortable: true
          },
          {
            width: '140px',

            title: '备件规格',
            key: 'bjModelSpec',
            type: JVXETypes.input,

            defaultValue: '',
            sortable: true
          },
          {
            title: '生产厂家',
            key: 'manuId_dictText',
            type: JVXETypes.normal,
            width: '220px',
            align: 'center',
            sortable: true,
          },
          // {
          //   width: '220px',
          //   title: '生产厂家',
          //   key: 'manuId',
          //   type: JVXETypes.selectSearch,
          //   // dictCode: '`iwt-wf`.common_manufacturer,manu_name,id, 1=1 order by manu_name asc',
          //   defaultValue: '2',
          //   align: 'center',
          //   options: this.manuList,
          //   sortable: true
          // },
          /* {
            width: '180px',

            title: '生产厂家',
            key: 'manuName',
            // type: JVXETypes.input,

            defaultValue: '',
            sortable: true
          }, */
          {
            width: '120px',

            title: '单位',
            key: 'unit',
            type: JVXETypes.select,
            dictCode: 'asset_unit',
            defaultValue: '1',
            align: 'center',
            sortable: true
          },
          {
            title: '备件类型',
            key: 'bpbjType',
            dictCode: 'bpbj_type',
            type: JVXETypes.select,
            width: '150px',
            placeholder: '请选择',
            align: 'center',
            validateRules: [
              {
                required: true, // 必填
                message: '请输入${title}' // 显示的文本
              }
            ],
            sortable: true,
            disabled: true
          },
          {
            title: '适配设备类型',
            key: 'devClassCode_dictText',
            type: JVXETypes.normal,
            width: '180px',
            align: 'center',
            sortable: true,
          },
          {
            title: '适配设备型号',
            key: 'devModelId_dictText',
            type: JVXETypes.normal,
            width: '180px',
            align: 'center',
            sortable: true,
          },
          // devModelId_dictText
          // {
          //   title: '适配设备型号',
          //   key: 'devModelId',
          //   type: JVXETypes.selectMultiple,
          //   showSearch: true,
          //   defaultActiveFirstOption: 'false',
          //   validateRules: [
          //     {
          //       required: true, // 必填
          //       message: '请输入${title}' // 显示的文本
          //     }
          //   ],
          //   width: '180px',
          //   defaultValue: '',
          //   options: this.devModelList,

          //   placeholder: '请选择${title}',
          //   sortable: true
          // },
          {
            title: '适配设备类型',
            key: 'devClassCode',
            type: JVXETypes.hidden,
            width: '180px',
            align: 'center',
            sortable: true,
          },
          {
            width: '100px',

            title: '寿命(月)',
            key: 'ageMonth',
            type: JVXETypes.inputNumber,
            align: 'center',
            // 表单验证规则
            validateRules: [
              {
                pattern: /^\+?[1-9]\d*$/, // 正则
                message: '${title}必须正整数'
              }
            ],
            defaultValue: '',
            sortable: true
          },
          {
            title: '操作',
            key: 'action',
            type: JVXETypes.slot,
            fixed: 'right',
            width: '130px',
            // minWidth: '60px',
            align: 'center',
            slotName: 'action',
          }
        ],
        dataSource: [],
        loading: true,
        devModelList: []

      }
    },
    // 计算属性，会监听依赖属性值随之变化
    computed: {
      ...mapGetters(['']),
      xTable () {
        return this.$refs?.vTable.$refs?.vxe.$refs.xTable ?? null
      }
    },
    // 监控data中的数据变化
    watch: {},
    // 生命周期 - 创建完成（可以访问当前this实例）
    async created () {



      this.loadData()
    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted () {

    },
    // 方法集合
    methods: {
      handleCopy (v) {
        const { row } = v
        this.$refs.vTable.addRows(this.$Jlodash.omit(row, ['id']))
      },
      handleEditClosed (rows, v) {

        console.info('editRows vvv=====', v)
        const { $table, col, value, type, column, row, rowId = '' } = rows
        // 判断单元格值是否被修改
        let field = column.property
        if (!$table.isUpdateByRow(row, field)) {
          return
        }

        if (row.id.indexOf('row') < 0) {
          this.xTable?.validate(row).then((errMap) => {
            // 校验通过
            if (!errMap) {
              this.loading = true
              const fields = this.tableColumns.map(item => item.key)
              const params = this.$Jlodash.pick(row, fields)
              postAction('/spareparts/devBpbjStandardInfo/edit', { ...params, id: row.id }).then(res => {
                if (res.success) {
                  this.$message.success('编辑成功')
                }
              }).finally(() => {
                this.loading = false
              })
            }
          })
        }
      },
      handleTableSave () {
        const $table = this.$refs.vTable
        let newData = $table.getNewDataWithId()
        if (!newData.length) {
          this.$message.error('无新增数据！')
          return
        }
        // const xTable = this.$refs.vTable.$refs.vxe.$refs.xTable
        const resultRows = newData.map(item => this.$Jlodash.omit(item, ['id']))

        $table.validate(newData).then((errMap) => {

          //   // 校验通过
          if (!errMap) {
            // 获取新增的数据

            console.log('-- 新增的数据：', resultRows)
            this.loading = true
            postAction('/spareparts/devBpbjStandardInfo/batchAdd', resultRows).then(res => {
              if (res.success) {
                this.$message.success(`保存成功！`)
              } else {
                this.$message.warn(`保存失败：` + res.message)
              }
            }).finally(() => {
              this.loading = false
              this.loadData()
            })
          }
        })
      },
      handleTableAdd () {
        const { devClassCode, devClassCode_dictText, manuId_dictText, manuId, modelName } = this.model
        this.$refs.vTable.pushRows([{
          bpbjType: 2,
          unit: '1',
          devClassCode_dictText: devClassCode_dictText,
          devClassCode: devClassCode,
          devModelId_dictText: modelName,
          manuId,
          manuId_dictText,
          devModelId: this.modelId
        }], {
          index: 0,
          setActive: true,
        })
      },
      loadData () {
        const params = {
          bpbjType: 2,
          devModelId: this.modelId
        }
        getAction('/spareparts/devBpbjStandardInfo/queryBpbjStandardByDevTypeIds', params).then(res => {
          if (res.success) {
            this.dataSource = res.result.records.map((item) => {
              return {
                ...item,
                // devModelId: item.devModelId_dictText,
                manuName: item.manuId_dictText
              }
            })
            this.selectedRows = []
          }
        }).finally(() => {
          this.loading = false
        })
      },
      handleDL (v) {
        console.info('==========del', v);

        const { row, rowId } = v
        if (rowId.indexOf('row_') > -1) {
          this.$refs.vTable.removeRows(row)
          return
        }

        deleteAction('/spareparts/devBpbjStandardInfo/delete', { id: row.id }).then(res => {
          if (res.success) {
            this.$refs.vTable.removeRows(row)
            this.$message.success('删除成功')
          }
        })

      },
    }
  }
</script>

<style lang='scss' scoped>


</style>